import { useCallback, useMemo } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useParams } from 'react-router-dom';
import { userInformationAtom } from '../../../Services/_states/auth.js';
import { templateSummaryFiltersAtom } from '../state/templateAtoms';
import { formatReportingDate } from '../constants/reportingConfig';

export default function useTemplateReportingScope(templateIdOverride) {
  const { botNumber } = useParams();
  const loggedInUser = useRecoilValue(userInformationAtom);
  const companyId = loggedInUser?.profile?.organisation?.organisation_id;
  const [filters, setFilters] = useRecoilState(templateSummaryFiltersAtom);

  const templateId = templateIdOverride ?? filters.template_id;

  const apiScope = useMemo(
    () => ({
      company_id: companyId,
      bot_number: botNumber,
      template_id: templateId,
      start_date: filters.start_date,
      end_date: filters.end_date,
    }),
    [botNumber, companyId, filters.end_date, filters.start_date, templateId]
  );

  const updateFilters = useCallback(
    (patch) => {
      setFilters((prev) => ({ ...prev, ...patch }));
    },
    [setFilters]
  );

  const applyDateRange = useCallback(
    (range) => {
      updateFilters({
        start_date: range?.startDate ?? null,
        end_date: range?.endDate ?? null,
        page: 0,
      });
    },
    [updateFilters]
  );

  const setTemplateId = useCallback(
    (id) => {
      updateFilters({ template_id: id ?? '' });
    },
    [updateFilters]
  );

  return {
    companyId,
    botNumber,
    filters,
    apiScope,
    updateFilters,
    applyDateRange,
    setTemplateId,
    formatSentDate: formatReportingDate,
  };
}
